import { render, staticRenderFns } from "./IDelTag.vue?vue&type=template&id=6a9c98e6&scoped=true&"
import script from "./IDelTag.vue?vue&type=script&lang=js&"
export * from "./IDelTag.vue?vue&type=script&lang=js&"
import style0 from "./IDelTag.vue?vue&type=style&index=0&id=6a9c98e6&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9c98e6",
  null
  
)

export default component.exports